<template>
<a :href="cta.cta_link" target="_blank" class="section small-top" style="margin-top: 20px" v-if="cta.cta_link">
  <div class="card card--white">
    <div class="card card--container row">
      <avatar :image="cta.cta_img" />
      <div class="margin-left">
        <h3>{{cta.cta_title}}</h3>
        <div>{{cta.cta_subtitle}}</div>
        <a :href="cta.cta_link" target="_blank">{{cta.cta_link_text}}</a>
      </div>
    </div>
  </div>
</a>
</template>

<script>
import avatar from "@/components/userImg";
export default {
  components: { avatar },
  props: ["cta"]
};
</script>

<style lang="less" scoped>
a, div, h3 {
  text-decoration: none !important;
}

.small-top {
  margin-top: 15px;
}

.margin-left {
  margin-left: 10px;
}
</style>
